export default __webpack_public_path__ + "static/media/live-stream-btn.e7a8acd1.svg";